import { render, staticRenderFns } from "./list-profile.vue?vue&type=template&id=574cbede&"
import script from "./list-profile.vue?vue&type=script&lang=js&"
export * from "./list-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports